module.exports = __webpack_public_path__ + "static/img/05no.3be2e96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/report/03month/05no.png
// module id = Kstc
// module chunks = 0